import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AppMenuitem } from '../app.menuitem';
import { RouterModule } from '@angular/router';
import { LayoutService } from '../../service/layout.service';

@Component({
  selector: 'app-menu',
  imports: [CommonModule, AppMenuitem, RouterModule],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss'
})
export class MenuComponent {
  model: MenuItem[] = [];
  ngOnInit() {
    const isAdmin = JSON.parse(localStorage.getItem('user') || '{}').isAdmin;

    this.model = [
      {
        label: 'Accueil',
        items: [
          {
            label: 'Tableau de bord', icon: 'pi pi-fw pi-home', routerLink: ['/']
          }
        ]
      },
      {
        label: 'Mes analyses',
        items: [
          {
            label: 'Historique', icon: 'pi pi-fw pi-history', routerLink: ['/historique']
          },
          {
            label: 'Gestion de la bankroll', icon: 'pi pi-dollar', routerLink: ['/bankroll']
          }
        ]
      },
      {
        label: 'Mes abonnements',
        items: [
          {
            label: 'Abonnements', icon: 'pi pi-fw pi-wallet', routerLink: ['/abonnement']
          }
        ]
      },

      {
        label: 'Mes Formations',
        items: [
          {
            label: 'Formations', icon: 'pi pi-fw pi-book', routerLink: ['/formations']
          }
        ]
      },
      {
        label: 'Investissement',
        items: [
          {
            label: 'Investir', icon: 'pi pi-fw pi-money-bill', routerLink: ['/investissement']
          }
        ]
      },
      {
        label: 'Profil',
        items: [
          {
            label: 'Mon compte', icon: 'pi pi-fw pi-user', routerLink: ['/profil']
          }
        ]
      }
    ];

    if (isAdmin) {
      this.model.splice(2, 0, {
        label: "Admin",
        items: [
          {
            label: 'Gérer les analyses', icon: 'pi pi-fw pi-cog', routerLink: ['/admin/prediction']
          },
          {
            label: 'Gérer les équipes', icon: 'pi pi-fw pi-users', routerLink: ['/admin/teams']
          },
          {
            label: 'Prédictions unitaires', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/admin/unit-prediction']
          },
          {
            label: 'Gérer les formations', icon: 'pi pi-book', routerLink: ['/admin/formations']
          },

          {
            label: 'Gérer les projets', icon: 'pi pi-fw pi-folder', routerLink: ['/admin/projects']
          },
          {
            label: 'Gérer les notifications', icon: 'pi pi-fw pi-bell', routerLink: ['/admin/notifications']
          }
        ]
      });
    }
  }
  constructor(public layoutService: LayoutService) {

  }
}
